module.exports = __webpack_public_path__ + "img/analyse-active.b1efe270.png";